import { https } from "../http";
import store from "../store";
import { setAddInvoiceSettingLoading, setAllInvoicesSetting,setAllStripeAccounts,setLoading } from "../store/reducers/settinginvoice";
import { showError } from "../utils/index";

// POST  // CREATE INVOICE SETTING
const createInvoicesSetting = async (data, callback) => {
  try {
    store.dispatch(setAddInvoiceSettingLoading(true));
    let response = await https().post("invoicesetting", data);
    console.log('response in the action',response);
    

    if (response?.status === 200) {
      //  getAllBillingConsumers()
      // getReports(false);
      callback?.();
    }

    return response
  } catch (error) {
    store.dispatch(setAddInvoiceSettingLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};



//get  INVOICE SETTING

const getInvoicesSetting = async (payload, showLoading = true) => {
  console.log('payload',payload);
  
    try {
      if (showLoading) store.dispatch(setLoading(true));
     let response = await https().get('invoicesetting/get-invoice-setting')

    
        
      if (response?.status === 200) {
        store.dispatch(setAllInvoicesSetting(response?.data));
        store.dispatch(setLoading(false));
        return response
      }

    } catch (error) {
      store.dispatch(setLoading(false));
      showError(error?.response?.data?.message, error?.response?.status);
      return false;
    }
  };


// EDIT INVOICE SETTING


const EditInvoicesSetting = async (data, showLoading = true) => {
  try {
    store.dispatch(setAddInvoiceSettingLoading(true));
    let response = await https().put(`/invoicesetting/${data?.id}`, data);

    if (response?.status === 200) {
        getInvoicesSetting(showLoading);
     
    }

    return response
  } catch (error) {
    store.dispatch(setAddInvoiceSettingLoading(false));
    showError(error?.response?.data?.message, error?.response?.status)
  }
};



// CREATE STRIPE ACCOUNT

const CreateStripeAccount = async (callback) => {
  try {
    store.dispatch(setAddInvoiceSettingLoading(true));
    let response = await https().get("invoicesetting/get-stripe-account-link");
    // console.log('response in the action',response);
    

    if (response?.status === 200) {
      //  getAllBillingConsumers()
      // getReports(false);
      callback?.();
    }

    return response
  } catch (error) {
    store.dispatch(setAddInvoiceSettingLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};


// GET  STRIPE LiNK ACCOUNT


const getStripAccountForInovices = async (payload, showLoading = true) => {
  console.log('payload',payload);
  
    try {
      if (showLoading) store.dispatch(setLoading(true));
     let response = await https().get('invoicesetting/links-stripe-accounts')

    
        
      if (response?.status === 200) {
        store.dispatch(setAllStripeAccounts(response?.data));
        store.dispatch(setLoading(false));
        return response
      }

    } catch (error) {
      store.dispatch(setLoading(false));
      showError(error?.response?.data?.message, error?.response?.status);
      return false;
    }
  };



export {
    createInvoicesSetting,
    getInvoicesSetting,
    EditInvoicesSetting,
    CreateStripeAccount,
    getStripAccountForInovices,

}